import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function ProofSection() {
  return <section className="bg-white py-20 px-4" data-id="element-152">
      <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-153">
        <FadeIn data-id="element-154">
          <div className="relative mx-auto max-w-md lg:max-w-full" data-id="element-155">
            <div className="absolute inset-0 bg-cream rounded-3xl transform -rotate-3 scale-105 opacity-80" data-id="element-156"></div>
            <img src="https://cdn.magicpatterns.com/uploads/31BBM6aHGA2zJYazZrQHUp/HYEgp-A5zCBfky1W8E2VD_(1).png" alt="Mujer profesional segura y desinflamada" className="relative z-10 w-full h-auto rounded-3xl shadow-xl object-cover" data-id="element-157" />
          </div>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-158">
          <div data-id="element-159">
            <h2 className="text-3xl md:text-4xl font-bold mb-8" data-id="element-160">
              Lo que cambia en{' '}
              <span className="italic text-terracotta" data-id="element-161">7 días</span>
            </h2>
            <div className="bg-cream p-8 rounded-3xl" data-id="element-162">
              <p className="text-xl leading-relaxed text-brown-body" data-id="element-163">
                No solo notarás que tu abdomen está más plano y blando al tacto;
                tu cara se verá menos hinchada, tus niveles de energía se
                estabilizarán y esa "neblina mental" que te impedía concentrarte
                desaparecerá por completo.
              </p>
              <p className="mt-6 text-lg font-medium text-brown-dark" data-id="element-164">
                Volverás a sentirte tú misma, lista para ponerte ese traje o
                pantalón con total confianza.
              </p>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}